import React from "react";
import {
  Eye,
  Plus,
  MonitorCog,
  WalletCards,
  CheckCircle2,
  CircleSlash2,
} from "lucide-react";
import { formatDateTime } from "../../../../../utils/dateFormatter";
import { ToastContainer } from "react-toastify";

const TerminalTable = ({ terminals, onView, onAddDrawer }) => {
  return (
    <>
    <ToastContainer/>
    
    <table className="w-full text-sm montserrat-font-1">
      <thead className="bg-green-100 text-gray-600 text-xs uppercase">
        <tr>
          <th className="p-4 text-left">Terminal ID</th>
          <th className="p-4 text-left">Terminal Name</th>
          <th className="p-4 text-left">Terminal Code</th>
          <th className="p-4 text-left">Device ID</th>
          <th className="p-4 text-left">Drawer</th>
          <th className="p-4 text-left">Created At</th>
          <th className="p-4 text-left">Status</th>
          <th className="p-4 text-left">Actions</th>
        </tr>
      </thead>

      <tbody>
        {terminals.length === 0 ? (
          <tr>
            <td colSpan="8" className="text-center py-10 text-gray-400">
              No terminals found
            </td>
          </tr>
        ) : (
          terminals.map((terminal) => (
            <tr
              key={terminal.pk_terminal_id}
              className="border-t hover:bg-gray-50"
            >
              <td className="p-4 text-gray-700 font-mono">
                #{terminal.pk_terminal_id}
              </td>

              <td className="p-4">
                <div className="flex items-center gap-2">
                  <div className="w-9 h-9 rounded-lg bg-green-50 border border-green-100 flex items-center justify-center">
                    <MonitorCog size={17} className="text-green-600" />
                  </div>

                  <div>
                    <p className="font-semibold text-gray-800">
                      {terminal.terminal_name || "-"}
                    </p>
                    <p className="text-xs text-gray-400">
                      Restaurant ID: {terminal.fk_restaurant_id || "-"}
                    </p>
                  </div>
                </div>
              </td>

              <td className="p-4 text-gray-700">
                <span className="px-2 py-1 bg-gray-100 rounded-md font-mono text-xs">
                  {terminal.terminal_code || "-"}
                </span>
              </td>

              <td className="p-4 text-gray-600 font-mono">
                {terminal.device_id || "-"}
              </td>

              <td className="p-4">
                <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs bg-blue-50 text-blue-700 border border-blue-100">
                  <WalletCards size={13} />
                  View in modal
                </span>
              </td>

             <td className="p-4 text-gray-600">
  {formatDateTime(terminal.created_at, true)}
</td>

              <td className="p-4">
                {String(terminal.status) === "1" ? (
                  <span className="flex items-center gap-1 px-3 py-1 rounded-full text-xs bg-green-100 text-green-700 w-fit">
                    <CheckCircle2 size={14} />
                    Active
                  </span>
                ) : (
                  <span className="flex items-center gap-1 px-3 py-1 rounded-full text-xs bg-red-100 text-red-600 w-fit">
                    <CircleSlash2 size={14} />
                    Inactive
                  </span>
                )}
              </td>

              <td className="p-4">
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => onView(terminal)}
                    className="relative group p-2 rounded-lg border hover:bg-blue-50 text-blue-600"
                  >
                    <Eye size={16} />

                    <span className="absolute z-50 bottom-full left-1/2 -translate-x-1/2 mb-1 px-2 py-1 text-xs bg-white border text-gray-700 rounded shadow opacity-0 group-hover:opacity-100 transition whitespace-nowrap">
                      View
                    </span>
                  </button>

                  <button
                    onClick={() => onAddDrawer(terminal)}
                    className="relative group p-2 rounded-lg border hover:bg-green-50 text-green-600"
                  >
                    <Plus size={16} />

                    <span className="absolute z-50 bottom-full left-1/2 -translate-x-1/2 mb-1 px-2 py-1 text-xs bg-white border text-gray-700 rounded shadow opacity-0 group-hover:opacity-100 transition whitespace-nowrap">
                      Add Drawer
                    </span>
                  </button>
                </div>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
    </>
  );
};

export default TerminalTable;